(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ExternalResourceRunController',ExternalResourceRunController);

    ExternalResourceRunController.$inject = ['$uibModalInstance', 'entity', 'ExternalResource'];

    function ExternalResourceRunController($uibModalInstance, entity, ExternalResource) {
        var vm = this;

        vm.externalResource = entity;
        vm.clear = clear;
        vm.confirmRun = confirmRun;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmRun (id) {
            ExternalResource.run({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
